import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";




const Hadear1 = () => {
  const [toggle, setToggle] = useState(false);

  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };


  return (
    <>

      <div className="section-header">
        <div className="header-wrapper">
          <div className="header-top-style-2">
            <div className="header-top-area-2">
              <div className="header-top-left">
                <li className="header-info-item-2" style={{ color: "white" }}>
                  <div className="header-info-icon-2">
                    <i className="fa-light fa-phone" />
                  </div>
                  <div className="header-info-content" >
                    <a style={{ color: "white" }} href="tel:+91 8770252599" className="header-info-link">+91 8770252599</a>
                  </div>
                </li>
              </div>
              <div className="header-top-right">
                <ul className="header-info header-info-list-2">
                  <li className="header-info-item-2">
                    <div className="header-info-icon-2">
                      <i className="fa-light fa-envelope" style={{ color: "white" }} />
                    </div>
                    <div className="header-info-content">
                      <a style={{ color: "white" }} href="mailto:info@mprahullogistics.com" className="header-info-link">info@mprahullogistics.com</a>
                    </div>
                  </li>
                  <li className="header-info-item-2">
                    <div className="header-info-icon-2">
                      <i className="fa-light fa-location-dot" style={{ color: "white" }} />
                    </div>
                    <div className="header-info-content">
                      <address style={{ color: "white" }} className="header-info-link is-link-to-text"> 275U, Dwarka City Katni-483501
                        {/* Reg. Off.-275 U, Jabalpur Road, Katni */}
                      </address>
                    </div>
                  </li>
                </ul>
                {/* <div>
                  <a href="/track-order">
                    <p style={{ color: "white", marginTop:"-9px" }}> <b>Track Order</b> </p>
                  </a>
                </div> */}
                <div className="social-menu is-text-link-white" >
                  <a href="https://www.facebook.com/100064046073062/about/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-facebook-f" style={{ color: "white" }} />
                  </a>
                  <a to="https://www.x.com" target="_blank" rel="noopener noreferrer">
                    <i style={{ color: "white" }} className="fa-brands fa-youtube" />
                  </a>

                  <a to="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                    <i style={{ color: "white" }} className="fa-brands fa-instagram" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <header className="header-bottom-style-2 tejbhan" >
            <div className="header-bottom-area header-bottom-area-2">
              <div className="header-bottom-left">
                <Link to="/">
                  <img src="assets/img/logo.png" alt="logo" width={200} height={100} />
                </Link>
              </div>
              <div className="header-bottom-center">
                <nav className="header-nav d-none d-xl-block" >
                  <ul className="header-nav-list" >
                    <li className="header-nav-item">
                      <Link to="/" className="header-nav-link">
                        Home
                      </Link>
                    </li>
                    <li className="header-nav-item">
                      <Link to="/about" className="header-nav-link">
                        About Us
                      </Link>
                    </li>
                    <li className="header-nav-item">
                      <Link to="/services" className="header-nav-link">
                        Services
                      </Link>
                    </li>
                    <li className="header-nav-item">
                      <Link to="/blog" className="header-nav-link">
                        Our Blog
                      </Link>
                    </li>
                    <li className="header-nav-item">
                      <Link to="/gallery" className="header-nav-link">
                        Our Gallery
                      </Link>
                    </li>
                    <li className="header-nav-item">
                      <Link to="/contact-us" className="header-nav-link">
                        Contact Us
                      </Link>
                    </li>
                    
                  </ul>
                </nav>
              </div>
              <div className="header-bottom-right">
                {/* Header Event */}
                <div className="header-user-event">
                  <button className="header-user-event-button header-user-event-button-cart">
                    <i className="fa-light fa-bag-shopping" />
                    <span className="product-number">2</span>
                  </button>
                  <Link to="/track-order" className="btn btn-primary d-none d-xl-flex">
                    Track Order
                    <div className="btn-icon">
                      <span>
                        <i className="fa-regular fa-arrow-right" />
                      </span>
                      <span>
                        <i className="fa-regular fa-arrow-right" />
                      </span>
                    </div>
                  </Link>
                  {/* Responsive Offcanvas Menu Button */}
                  <button className="header-user-event-button navbar-toggler d-block d-xl-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasManu" aria-controls="offcanvasManu">
                    <i className="fa-regular fa-bars" style={{ color: "" }} />
                  </button>
                  {/* Responsive Offcanvas Menu Button */}
                  <ul className="get-touch-info-list flex-grow-1">
                    <li>
                      <div className="icon-rounded-full is-gradient">
                        <i className="fa-light fa-phone" />
                      </div>
                      <div className="content">
                        <span className="tc-body">Call us</span>
                        <a href="tel:+5323213333">+532 321 33 33</a>
                      </div>
                    </li>
                  </ul>
                </div>
                {/* Header Event */}
              </div>
            </div>
          </header>
          {/* Header Bottom Area */}
        </div>
      </div>

      <div className="offcanvas offcanvas-start block-bg-dark" tabIndex={-1} id="offcanvasManu" aria-labelledby="offcanvasManu">
        <div className="offcanvas-header">
          <button type="button" className="btn-close btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body">
          <Link to="/" className="d-flex justify-content-center mb-4">
            <img src="assets/img/logo.png" alt="logo" width={200} height={75} className="img-fluid" />
          </Link>
          <nav className="category-menu">
            <ul>
              {/* <li className="category">
                <a href="#">Demo</a>
                <ul className="subcategory">
                  <li><a href="index.html">Home 1</a></li>
                  <li><a href="index-2.html">Home 2</a></li>
                  <li><a href="index-3.html">Home 3</a></li>
                  <li><a href="index-4.html">Home 4</a></li>
                  <li><a href="index-5.html">Home 5</a></li>
                </ul>
              </li> */}

              <li className="category">
                <Link to="/" onClick={closemenu}>Home</Link>
              </li>
              <li className="category">
                <Link to="/about" onClick={closemenu}>About Us</Link>
              </li>
              <li className="category">
                <Link to="/services" onClick={closemenu}>Services</Link>
              </li>
              <li className="category">
                <Link to="/blog" onClick={closemenu}> Our Blog</Link>
              </li>
              <li className="category">
                <Link to="/gallery" onClick={closemenu}>Our Gallery</Link>
              </li>
              <li className="category">
                <Link to="/contact-us" onClick={closemenu}>Contact Us</Link>
              </li>
              
              <hr />
              <p style={{ marginTop: "-30px" }}><div className="d-flex align-items-center flex-wrap gap-4 gap-lg-5 mt-5">
                {/* <Link onClick={closemenu} className="btn btn-secondary" to="/track-order">Track Order<div className="btn-icon">
                  <span>
                    <i className="fa-regular fa-arrow-right" />
                  </span>
                  <span>
                    <i className="fa-regular fa-arrow-right" />
                  </span>
                </div>
                </Link> */}
                <div>
                </div>
              </div>
              </p>


            </ul>
          </nav>

          <div className="social-menu justify-content-center mt-3">
            <a to="http://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-facebook-f" />
            </a>

            <a to="http://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-instagram" />
            </a>
            <a to="http://www.x.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-youtube" />
            </a>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-top" tabIndex={-1} id="searchBar" aria-labelledby="searchBarLabel">
        <div className="offcanvas-header">
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body">
          <div className="container">
            <div className="row">
              <div className="col col-lg-8 mx-auto">
                <h5 className="offcanvas-title mb-2" id="searchBarLabel">Search by keyword</h5>
                <form action="#" method="get" className="position-relative">
                  <input type="search" placeholder="Search here" className="form-input pe-5" required />
                  <button className="search-button"><i className="fa-solid fa-magnifying-glass" /></button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>





    </>
  )
}

export default Hadear1